<template>
    <el-container>
        <el-header height="auto">
            <div class="header_top_box">
                <div class="header_top">
                    <div class="top_left">
                        <div class="header_item">
                            <span>{{ basic_info['WEB_WELCOME'] }}<span class="exchange_box">今日汇率：人民币：{{ basic_info['WEB_RMB'] }}；台币：{{ basic_info['WEB_TAIWAN'] }}；</span></span>
                        </div>
                    </div>
                    <div class="top_right">
                        <div v-if="user_data == null"
                             class="header_item">
                            <span>請
                                <router-link class="red"
                                             :to="`/Login`">登錄</router-link>
                            </span>
                        </div>
                        <div v-else
                             class="header_item">
                            <span>歡迎您~！ {{ user_data.user_name }} <a href="#"
                                   @click="handleLoginOut()">退出登录</a>
                            </span>
                        </div>
                        <div class="header_item">
                            <span class="header_icon">|</span>
                        </div>
                        <div class="header_item">
                            <router-link :to="`/Center`">
                                會員中心
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="header_bottom_box">
                <div class="header_bottom">
                    <div class="logo">
                        <img src="../../public/img/logo.png">
                    </div>
                    <div class="bottom_right">
                        <div class="search_box">
                            <input v-model="search">
                            <el-button @click="goSearch()">
                                <i class="el-icon-search" />
                            </el-button>
                        </div>
                        <div class="shop_info">
                            <router-link class="shop_cart"
                                         :to="`/Cart`">
                                <i class="el-icon-shopping-cart-1" /><span>購物車</span><span></span>
                            </router-link>
                            <router-link class="red"
                                         :to="`/OrderList`">
                                我的訂單
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </el-header>
    </el-container>
</template>

<script>
import { zhTransform } from "@/utils";
import { mapState } from "vuex";
export default {
    data() {
        return {
            search: "",
        };
    },
    computed: {
        ...mapState("BasicInfo", ["basic_info"]),
        ...mapState("loginUser", ["user_data", "islogining"]),
    },
    methods: {
        handleLoginOut() {
            this.$store.dispatch("loginUser/loginOut");
        },
        goSearch() {
            if (this.search) {
                this.$router.push({
                    name: "Search",
                    query: { search: zhTransform(this.search, "traditional") },
                });
            } else {
                this.$message({
                    type: "error",
                    message: "请输入您要查询的商品",
                    center: true,
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.el-header {
    width: 100%;
    background-color: #f9f9f9;
    padding: 0;
    font: 12px "Hiragino Sans GB", "simsun", "Arial";
    color: #646464;
    min-width: 1240px;

    .header_top_box {
        background-color: #f9f9f9;

        .header_top {
            color: #646464;
            font-size: 12px;
            height: 34px;
            width: 1240px;
            margin: 0 auto;
            border-bottom: 1px solid #f2f2f2;
            .top_left {
                float: left;
            }

            .top_right {
                float: right;
            }

            .header_item {
                padding: 5px 0 0 10px;
                height: 24px;
                line-height: 24px;
                float: left;
                .exchange_box {
                    margin-left: 40px;
                    color: #ff2832;
                }
            }

            a {
                color: #646464;
            }
        }
    }
    .header_bottom_box {
        background-color: #fff;
        .header_bottom {
            height: auto;
            overflow: hidden;
            height: 100px;
            width: 1240px;
            margin: 0 auto;
            .logo {
                float: left;
                margin-top: 8px;
            }
            .bottom_right {
                margin-top: 20px;
                margin-left: 362px;
                .search_box {
                    height: 48px;
                }
            }
            .bottom_right {
                .search_box {
                    float: left;
                    input {
                        width: 398px;
                        height: 18px;
                        border: 2px solid #ff2832;
                        border-right: none;
                        padding: 9px 0 9px 10px;
                        color: #323232;
                        float: left;
                        outline: none;
                    }
                    button {
                        height: 40px;
                        border: 2px solid #ff2832;
                        cursor: pointer;
                        float: left;
                        background-color: #ff2832;
                        color: #fff;
                        border-radius: 0px;
                        i {
                            color: #fff;
                            font-size: 16px;
                            font-weight: bold;
                        }
                    }
                }
                .shop_info {
                    float: left;
                    margin-left: 90px;
                    height: auto;
                    overflow: hidden;
                    a {
                        color: #646464;
                        background-color: #f6f6f6;
                        text-align: center;
                        width: 86px;
                        height: 36px;
                        border: 2px solid #dcdcdc;
                        text-align: center;
                        line-height: 36px;
                        float: left;
                        font-size: 14px;
                        border-left: none;
                    }
                    .shop_cart {
                        float: left;
                        border-color: #ff2832;
                        border-left: 2px solid #ff2832;
                        background-color: #ff2832;
                        width: 117px;
                        height: 36px;
                        color: #fff;
                        font-size: 16px;
                        text-align: center;
                        i {
                            font-size: 24px;
                            line-height: 36px;
                            float: left;
                            margin-left: 14px;
                        }
                        span {
                            line-height: 36px;
                            height: 36px;
                            float: left;
                            margin-left: 6px;
                        }
                    }
                    .shop_cart:hover {
                        background-color: #f6f6f6;
                        border: 2px solid #dcdcdc;
                        color: #ff2832;
                        font-size: 16px;
                    }
                }
            }
        }
    }
}
</style>
